import { HumanPregnantIcon } from './HumanPregnantIcon';

/**
 * author: Google
 * id 05DB88BC-FA28-4DF1-8308-541E338E0234
 * name human-pregnant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-pregnant.svg
 * tags
 * - People / Family 
 */
export const PregnantWomanIcon = HumanPregnantIcon;
export default PregnantWomanIcon